import axios, { AxiosInstance, AxiosResponse } from 'axios'

import { captureServerError, captureUnexpectedErrCode } from '@/shared/sentry/api'
import { addApiBreadcrumb } from '@/shared/sentry/breadcrumb'
import { RequestHeaderType, ResponseDataType } from '@/shared/types/api'
import { ERRORCODE } from '@/shared/types/errorCode'

export const generateGuid = () => {
  const s = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  return `${s()}${s()}-${s()}-${s()}-${s()}-${s()}${s()}${s()}`
}

const httpData = (Header: RequestHeaderType, Body?: any) => {
  return JSON.stringify({
    Header,
    Body,
  })
}

class CustomAxios {
  private axiosInstance: AxiosInstance
  private readonly baseURL: string

  constructor() {
    this.baseURL = import.meta.env.VITE_APP_SERVER_BASE_URL as string
    this.axiosInstance = axios.create({
      baseURL: this.baseURL,
    })
  }

  //T : request Body Type
  //U : response Body Type
  async post<T, U>(Header: RequestHeaderType, Body: T) {
    try {
      addApiBreadcrumb('request', { cmdType: Header.CmdType })

      return await this.axiosInstance
        .post('', httpData(Header, Body))
        .then((res: AxiosResponse<ResponseDataType<U>>) => {
          const { data } = res

          if (data.Header.ResultCd !== ERRORCODE.SUCCESS) {
            addApiBreadcrumb('response', {
              cmdType: Header.CmdType,
              ResultCd: data.Header.ResultCd,
              ResultMsg: data.Header.ResultMsg,
            })
            captureUnexpectedErrCode(data.Header)
          }
          return data
        })
    } catch (error) {
      alert('요청 중 문제가 발생했습니다.\n잠시 후 다시 시도해주세요.')
      console.error('Error POST request:', error)
      captureServerError(error, String(Header.CmdType))
      throw error
    }
  }
}

export const fetch = new CustomAxios()
